import { sendCommonInfoEvent, setRegisterEnd, setRegisterStart } from '../internal/commonMetric';
import { getGlobalProps, startGlobalPropsMonitor } from '../internal/inappGlobalProps';
import { getJsbFirstScreenRequests, startJsbMonitor } from '../internal/jsb';
import { startResourceMonitor } from '../internal/resourceMonitor';
const sendFromGeckoEvent = (slardarClient, config) => {
    void getGlobalProps('htmlFromGecko').then((htmlFromGecko) => {
        if (htmlFromGecko) {
            slardarClient.callClient('sendEvent', {
                name: 'from_gecko',
                categories: {
                    html: htmlFromGecko.fromGecko,
                    resFrom: htmlFromGecko.resFrom,
                },
            });
            // add context to analyze performance different of set html gecko
            slardarClient.updateContext('htmlResFrom', htmlFromGecko.resFrom);
            // - gecko // 本地 gecko
            // - gecko_update // gecko 远程包
            // - cdn_cache // CDN 本地缓存
            // - cdn // CDN 远程包
            // - buildIn // 内置包
            // - builtin // 内置包
            // - offline // 本地文件
        }
    });
    void startResourceMonitor(config.geckoResPath, (res) => {
        slardarClient.callClient('sendEvent', {
            name: 'from_gecko',
            categories: {
                resource: res.fromGecko,
                path: res.path,
                isFirstScreen: res.isFirstScreen,
                resourceType: res.resourceType,
            },
        });
    });
};
const sendContainerInitEvent = (slardarClient) => {
    void getGlobalProps('containerInitCost').then((containerInitCost) => {
        if (containerInitCost) {
            slardarClient.callClient('sendCustomPerfMetric', {
                name: 'container_init_cost',
                value: containerInitCost,
            });
        }
    });
};
const sendInappInfoEvent = (slardarClient) => {
    void Promise.all([getGlobalProps('containerInitTotalTime'), getGlobalProps('deviceScore')]).then(([containerInitTotalTime, deviceScore]) => {
        const metrics = {};
        if (containerInitTotalTime) {
            metrics.containerInitTotalTime = containerInitTotalTime;
        }
        if (deviceScore) {
            metrics.deviceScore = deviceScore.score;
        }
        if (Object.keys(metrics).length > 0) {
            slardarClient.callClient('sendEvent', {
                name: 'ttapplugin_inapp_info',
                metrics,
            });
        }
    });
};
const preRegister = async (jsb, slardarClient) => {
    if (!jsb[0]) {
        return;
    }
    startJsbMonitor(jsb, slardarClient);
    startGlobalPropsMonitor(jsb[0]);
    const p1 = getGlobalProps('appVersion')
        .then((appVersion) => {
        if (appVersion) {
            slardarClient.updateContext('app_version', appVersion);
        }
    })
        .catch(() => {
        //do nothing
    });
    const p2 = getGlobalProps('deviceScore')
        .then((deviceScore) => {
        if (deviceScore) {
            slardarClient.updateContext('device_score', deviceScore.scoreRounded.toString());
        }
    })
        .catch(() => {
        //do nothing
    });
    const p3 = getGlobalProps('networkLevel')
        .then((networkLevel) => {
        if (networkLevel) {
            slardarClient.updateContext('network_level', networkLevel.toString());
        }
    })
        .catch(() => {
        //do nothing
    });
    await Promise.all([p1, p2, p3]);
};
const postRegister = (slardarClient, config) => {
    if (!config.disableGeckoCheck) {
        sendFromGeckoEvent(slardarClient, config);
    }
    sendContainerInitEvent(slardarClient);
    sendInappInfoEvent(slardarClient);
    sendCommonInfoEvent(slardarClient);
};
const getFirstScreenRequests = () => {
    return getJsbFirstScreenRequests();
};
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export const createScenario = (jsb, config = {}) => {
    const jsbArr = [];
    if (Array.isArray(jsb)) {
        jsbArr.push(...jsb);
    }
    else {
        jsbArr.push(jsb);
    }
    const scenario = (slardarClient) => {
        return {
            setRegisterStart,
            setRegisterEnd,
            preRegister: async () => {
                await preRegister(jsbArr, slardarClient);
            },
            postRegister: () => {
                postRegister(slardarClient, config);
            },
            getFirstScreenRequests,
            getState: () => ({
                type: 'inapp',
                jsb: jsbArr[0],
            }),
        };
    };
    return scenario;
};
//# sourceMappingURL=inapp.js.map